import React, { useState } from 'react';
import { EventNotificationService, useEventNotification } from '../../../../framework/services/event-notification';
import { ProjectEvents } from '../../events';
import * as formService from '../../form-services/assess-record-mat';
import { IMaterialCallout } from '../../../../entities-generated/common/material-callout';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { BwjGrid, Row, Col } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { BwjTextField } from '../../../../framework/components/bwj-text-field';
import { PanelType } from '@fluentui/react';
import { BwjLabelField } from '../../../../framework/components/bwj-label-field';

interface IMaterialEditorPanelProps {
  onMaterialUpdated: (material: IMaterialCallout) => void;
}

const subscriberId = 'Panel.MaterialEditor';

export const MaterialEditorPanel: React.FunctionComponent<IMaterialEditorPanelProps> = (props) => {
  const [showPanel, setShowPanel] = useState(false);
  const formModel = formService.useFormModel(subscriberId);
  const hasUnsavedChanges = formService.useHasUnsavedChanges(formModel, false);

  useEventNotification((args: IMaterialCallout) => {
    formService.initializeService(args);
    setShowPanel(true);
  }, [], ProjectEvents.MaterialEditorPanel_Launch, subscriberId);

  const onClosePanel = () => {
    EventNotificationService.dispatch(ProjectEvents.LaborEditorPanelFreeToClose);
    setShowPanel(false);
  }

  const onSaveChanges = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      if(result.isValid) {
        const mat = formService.toMaterialCallout();
        props.onMaterialUpdated(mat);
        onClosePanel();
      }
    });
  }

  return (
    <BwjSidePanel
      showPanel={showPanel}
      title={'Plan Material Usage'}
      panelType={PanelType.smallFixedFar}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Save changes',
        disabled: hasUnsavedChanges === false,
        onClick: onSaveChanges
      }, {
        buttonStyle: BwjButtonType.DefaultStandard,
        text: 'Cancel',
        onClick: onClosePanel
      }]}
      onDismiss={onClosePanel}
    >
      <BwjGrid>
        {formModel.isStandardMaterial === false ? <>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjTextField
              id={formService.description.id}
              required={true}
              label={formService.description.description}
              onUpdate={formService.description.onUpdate}
              input={formModel.description}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjTextField
              id={formService.vendorUrl.id}
              required={true}
              label={formService.vendorUrl.description}
              onUpdate={formService.vendorUrl.onUpdate}
              input={formModel.vendorUrl}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={6}>
            <BwjTextField
              id={formService.pricePerUnit.id}
              required={true}
              label={formService.pricePerUnit.description}
              onUpdate={formService.pricePerUnit.onUpdate}
              input={formModel.pricePerUnit}
              filter={/^[\d.]*$/}
            />
          </Col>
          <Col small={6}>
            <BwjTextField
              id={formService.quantity.id}
              required={true}
              label={formService.quantity.description}
              onUpdate={formService.quantity.onUpdate}
              input={formModel.quantity}
              filter={/^\d*$/}
            />
          </Col>
        </Row>
        </>
        :
        <>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
            <BwjLabelField
              id={formService.description.id}
              label={formService.description.description}
              value={formModel.description.value}
            />
          </Col>
        </Row>
        <Row bottomSpacing={Spacing.Large}>
          <Col small={6}>
            <BwjTextField
              id={formService.quantity.id}
              required={true}
              label={formService.quantity.description}
              onUpdate={formService.quantity.onUpdate}
              input={formModel.quantity}
              filter={/^\d*$/}
            />
          </Col>
        </Row>
        </>}
      </BwjGrid>
    </BwjSidePanel>
  );
};
